import { useMemo, type PropsWithChildren } from "react";
import { GraphemeDrillContext, type GraphemeDrillContextValue } from "#grapheme-drill-context";
import { WordDrillContext, type WordDrillContextValue } from "#word-drill-context";

export function GraphemeDrillContextProvider({
  children,
  drillType,
  front,
  slice,
}: PropsWithChildren<GraphemeDrillContextValue>) {
  const value = useMemo(() => ({ drillType, front, slice }), [drillType, front, slice]);
  return <GraphemeDrillContext.Provider value={value}>{children}</GraphemeDrillContext.Provider>;
}

export function WordDrillContextProvider({
  characterBacks,
  children,
  drillType,
  sentence,
}: PropsWithChildren<WordDrillContextValue>) {
  const value = useMemo(
    () => ({ characterBacks, drillType, sentence }),
    [characterBacks, drillType, sentence],
  );
  return <WordDrillContext.Provider value={value}>{children}</WordDrillContext.Provider>;
}
